import api from '@/services/api.js';

export default { 
    async add(event, portfolio){
        const eventResponse = await api.post('/events', event);
        portfolio.events.push(eventResponse.data);
        const portfolioResponse = await api.put('/portfolios/' + portfolio.id, portfolio);

        return portfolioResponse.data ? eventResponse : portfolioResponse;
    },
    update(event){
        return api.put('/events/' + event.id, event);
    },
    delete(eventId){
        return api.delete('/events/' + eventId);
    }
}